import ThemifyIcon from "./ThemifyIcon.vue";

export default ThemifyIcon;



//////////////////
// WEBPACK FOOTER
// ./~/vue-themify-icons/index.js
// module id = mS1i
// module chunks = 5